import api from '@/services/Api';

class VenueTypes {
  /**
   * @returns {AxiosPromise<any>}
   */
  static all() {
    return api.get('/ref/venue-types');
  }
}

export default VenueTypes;
